// utils/window.ts
export function openInNewTab(url) {
    window.open(url, "_blank", "noopener,noreferrer");
}